import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Layout, Input, Switch, Form, Select } from 'antd';
import { DetailForm, AuthButton, Radio, DatePicker } from '../../core/CoreForm';
import { Header, ContentEx as Content, Footer, FunctionTitle, CommonMessage, FooterButtonArea } from '../../core/CorePageContents';
import styles from './QualificationEdit.module.css';
import { setMessages, message } from '../../../modules/core/commonMessageModule';
import AuthButtonStyles from '../../core/css/AuthButton.module.css';
import { storedApiResult, initApiResult } from '../../../modules/core/bffApiModule';
import * as Module from '../../../modules/prime/qualification/qualificationModule';
import * as Model from '../../../modules/prime/qualification/qualificationModel';
import * as CONSTANTS from '../../../constants/constants';
import * as constantsUtils from '../../../utils/constantsUtils';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as formatUtils from '../../../utils/formatUtils';
import * as validationRules from '../../../validation/coreRules';
import { initMessages } from '../../../modules/core/commonMessageModule';
import moment from 'moment';
import { isNullOrEmpty } from '../../../utils/utils';
const { TextArea } = Input;

interface titleInterface {
  title: string;
}

export const QualificationEdit = (props: titleInterface) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [form] = Form.useForm();
  const dataRow = useSelector(Module.storedDataRow);
  const apiResult = useSelector(storedApiResult);
  const processType = window.location.pathname === CONSTANTS.PATH_PRIME_QUALIFICATIONS_ADD ? CONSTANTS.PROCESS_TYPE_ADD : CONSTANTS.PROCESS_TYPE_EDIT
  const ccusFlagSelected = useSelector(Module.storedCcusFlagSelected);

  const isNullOrNan = (val: any): boolean => {
    return val == null || isNaN(val);
  }

  useEffect(() => {
    if (dataRow.originalQualificationId === "" && processType === CONSTANTS.PROCESS_TYPE_EDIT) {
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_DETAIL);
    }

    // 更新API実行後、APIエラーメッセージが設定されていなければ画面遷移します。
    if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode && CONSTANTS.REQUEST_METHOD_PUT === apiResult.requestMethod) {

      if (processType === CONSTANTS.PROCESS_TYPE_ADD) {
        // 成功メッセージを設定します。
        const setMessage: message = {
          message: messagesUtils.getMessage("SUCCESS_ADD", ["独自資格"])
          , messageType: CONSTANTS.MESSAGE_TYPE_SUCCESS
        }
        dispatch(setMessages([setMessage]));
        history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
      } else {
        // 成功メッセージを設定します。
        const setMessage: message = {
          message: messagesUtils.getMessage("SUCCESS_UPDATE", ["独自資格"])
          , messageType: CONSTANTS.MESSAGE_TYPE_SUCCESS
        }
        dispatch(setMessages([setMessage]));
        history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_DETAIL);
      }
    }
  },
    [apiResult]
  );

  // 手当必要時間、月手当必要日数を取得
  const getInspection = (allowanceType: string, allowanceInspectionType: string, allowanceInspectionTime: string, monthlyAllowanceInspectionDays: string) => {
    let inspectionTime: number;
    let monthlyInspectionDays: number;
    if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.NONE.code) {
      inspectionTime = NaN;
      monthlyInspectionDays = NaN;
    } else {
      if (allowanceInspectionType == CONSTANTS.ALLOWANCE_INSPECTION_TYPE.EXIST.code) {
        if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
          inspectionTime = parseInt(allowanceInspectionTime);
          monthlyInspectionDays = parseInt(monthlyAllowanceInspectionDays);
        } else {
          inspectionTime = parseInt(allowanceInspectionTime);
          monthlyInspectionDays = NaN;
        }
      } else {
        if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
          inspectionTime = NaN;
          monthlyInspectionDays = 1;
        } else {
          inspectionTime = NaN;
          monthlyInspectionDays = NaN;
        }
      }
    }

    return [inspectionTime, monthlyInspectionDays];
  }

  // 日当から月手当に変わる条件の日数、日当から月手当に変わった時の金額を取得
  const getCeilingDailyAllowance = (allowanceType: string, ceilingDailyAllowanceInspectionDaysValue: string, ceilingDailyAllowanceAmountValue: string) => {
    let ceilingDailyAllowanceInspectionDays: number;
    let ceilingDailyAllowanceAmount: number;
    if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
      ceilingDailyAllowanceInspectionDays = ceilingDailyAllowanceInspectionDaysValue === "" ? NaN : parseInt(ceilingDailyAllowanceInspectionDaysValue);
      ceilingDailyAllowanceAmount = ceilingDailyAllowanceAmountValue === "" ? NaN : parseInt(ceilingDailyAllowanceAmountValue);
    } else {
      ceilingDailyAllowanceInspectionDays = NaN;
      ceilingDailyAllowanceAmount = NaN;
    }

    return [ceilingDailyAllowanceInspectionDays, ceilingDailyAllowanceAmount];
  }

  /**
   * 画面アクション
   * 
   */
  // 技能レベル適用変更時アクション
  const onChangeCcusFlag = (value: any) => {
    dispatch(Module.selectCcusFlag(value));
  }

  // 確定ボタン押下時アクション（入力エラー無）
  const onSubmit = (values: any) => {

    const validateResult: boolean = validate(values);
    if (!validateResult) {
      scrollToTop();
      return ;
    }

    let messageCode = "";
    if (processType === CONSTANTS.PROCESS_TYPE_ADD) {
      messageCode = "CONFIRM_ADD";
    } else {
      messageCode = "CONFIRM_UPDATE";
    }
    if (!window.confirm(messagesUtils.getMessage(messageCode, ["独自資格"]))) {
      return;
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // 手当条件の値を取得
    let [inspectionTime, monthlyInspectionDays] = getInspection(values.allowanceType, values.allowanceInspectionType, values.allowanceInspectionTime, values.monthlyAllowanceInspectionDays);
    let [ccusInspectionTime4, ccusMonthlyInspectionDays4] = getInspection(values.ccusAllowanceType4, values.ccusAllowanceInspectionType4, values.ccusAllowanceInspectionTime4, values.ccusMonthlyAllowanceInspectionDays4);
    let [ccusInspectionTime3, ccusMonthlyInspectionDays3] = getInspection(values.ccusAllowanceType3, values.ccusAllowanceInspectionType3, values.ccusAllowanceInspectionTime3, values.ccusMonthlyAllowanceInspectionDays3);
    let [ccusInspectionTime2, ccusMonthlyInspectionDays2] = getInspection(values.ccusAllowanceType2, values.ccusAllowanceInspectionType2, values.ccusAllowanceInspectionTime2, values.ccusMonthlyAllowanceInspectionDays2);
    let [ccusInspectionTime1, ccusMonthlyInspectionDays1] = getInspection(values.ccusAllowanceType1, values.ccusAllowanceInspectionType1, values.ccusAllowanceInspectionTime1, values.ccusMonthlyAllowanceInspectionDays1);

    // 日当から月手当に変わる値を取得
    let [ceilingDailyAllowanceInspectionDays, ceilingDailyAllowanceAmount] = getCeilingDailyAllowance(values.allowanceType, values.ceilingDailyAllowanceInspectionDays, values.ceilingDailyAllowanceAmount);
    let [ccusCeilingDailyAllowanceInspectionDays4, ccusCeilingDailyAllowanceAmount4] = getCeilingDailyAllowance(values.ccusAllowanceType4, values.ccusCeilingDailyAllowanceInspectionDays4, values.ccusCeilingDailyAllowanceAmount4);
    let [ccusCeilingDailyAllowanceInspectionDays3, ccusCeilingDailyAllowanceAmount3] = getCeilingDailyAllowance(values.ccusAllowanceType3, values.ccusCeilingDailyAllowanceInspectionDays3, values.ccusCeilingDailyAllowanceAmount3);
    let [ccusCeilingDailyAllowanceInspectionDays2, ccusCeilingDailyAllowanceAmount2] = getCeilingDailyAllowance(values.ccusAllowanceType2, values.ccusCeilingDailyAllowanceInspectionDays2, values.ccusCeilingDailyAllowanceAmount2);
    let [ccusCeilingDailyAllowanceInspectionDays1, ccusCeilingDailyAllowanceAmount1] = getCeilingDailyAllowance(values.ccusAllowanceType1, values.ccusCeilingDailyAllowanceInspectionDays1, values.ccusCeilingDailyAllowanceAmount1);

    let sendRequest: Model.putDataList.Request = {
      processType: processType
      , ccusFlag: ccusFlagSelected ? CONSTANTS.CCUS_FLAG.ON : CONSTANTS.CCUS_FLAG.OFF // 選択状態をコード値に変換
      , originalQualificationId: dataRow.originalQualificationId
      , originalQualificationNo: processType === CONSTANTS.PROCESS_TYPE_ADD ? values.originalQualificationNo : dataRow.originalQualificationNo
      , originalQualificationName: values.originalQualificationName
      , allowanceType: values.allowanceType
      , allowanceInspectionType: values.allowanceInspectionType
      , allowanceInspectionTime: inspectionTime
      , monthlyAllowanceInspectionDays: monthlyInspectionDays
      , allowanceAmount: values.allowanceType === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? NaN : parseInt(values.allowanceAmount)
      , ceilingDailyAllowanceInspectionDays: ceilingDailyAllowanceInspectionDays
      , ceilingDailyAllowanceAmount: ceilingDailyAllowanceAmount
      , deadlineExist: values.deadlineExist === true ? CONSTANTS.EXIST_DEADLINE.EXIST.code : CONSTANTS.EXIST_DEADLINE.NONE.code
      , deadlineStartDate: values.deadlineExist === true ? formatUtils.formatDateHyphen(values.deadlineStartDate) : ""
      , deadlineEndDate: values.deadlineExist === true ? formatUtils.formatDateHyphen(values.deadlineEndDate) : ""
      , levelRangeTo: values.allowanceType === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? 0 : Number(values.levelRangeTo) // 手当区分なしは対象次数0とする
      , remarks1: values.remarks1
      , remarks2: values.remarks2
      , updateDatetime: dataRow.updateDatetime
      , ccusAllowanceType4: values.ccusAllowanceType4
      , ccusAllowanceInspectionType4: values.ccusAllowanceInspectionType4
      , ccusAllowanceInspectionTime4: ccusInspectionTime4
      , ccusMonthlyAllowanceInspectionDays4: ccusMonthlyInspectionDays4
      , ccusAllowanceAmount4: values.ccusAllowanceType4 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? NaN : parseInt(values.ccusAllowanceAmount4)
      , ccusCeilingDailyAllowanceInspectionDays4: ccusCeilingDailyAllowanceInspectionDays4
      , ccusCeilingDailyAllowanceAmount4: ccusCeilingDailyAllowanceAmount4
      , ccusLevelRangeTo4: values.ccusAllowanceType4 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? 0 : Number(values.ccusLevelRangeTo4) // 手当区分なしは対象次数0とする
      , ccusLevelUpdateDatetime4: dataRow.ccusLevelUpdateDatetime4
      , ccusAllowanceType3: values.ccusAllowanceType3
      , ccusAllowanceInspectionType3: values.ccusAllowanceInspectionType3
      , ccusAllowanceInspectionTime3: ccusInspectionTime3
      , ccusMonthlyAllowanceInspectionDays3: ccusMonthlyInspectionDays3
      , ccusAllowanceAmount3: values.ccusAllowanceType3 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? NaN : parseInt(values.ccusAllowanceAmount3)
      , ccusCeilingDailyAllowanceInspectionDays3: ccusCeilingDailyAllowanceInspectionDays3
      , ccusCeilingDailyAllowanceAmount3: ccusCeilingDailyAllowanceAmount3
      , ccusLevelRangeTo3: values.ccusAllowanceType3 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? 0 : Number(values.ccusLevelRangeTo3) // 手当区分なしは対象次数0とする
      , ccusLevelUpdateDatetime3: dataRow.ccusLevelUpdateDatetime3
      , ccusAllowanceType2: values.ccusAllowanceType2
      , ccusAllowanceInspectionType2: values.ccusAllowanceInspectionType2
      , ccusAllowanceInspectionTime2: ccusInspectionTime2
      , ccusMonthlyAllowanceInspectionDays2: ccusMonthlyInspectionDays2
      , ccusAllowanceAmount2: values.ccusAllowanceType2 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? NaN : parseInt(values.ccusAllowanceAmount2)
      , ccusCeilingDailyAllowanceInspectionDays2: ccusCeilingDailyAllowanceInspectionDays2
      , ccusCeilingDailyAllowanceAmount2: ccusCeilingDailyAllowanceAmount2
      , ccusLevelRangeTo2: values.ccusAllowanceType2 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? 0 : Number(values.ccusLevelRangeTo2) // 手当区分なしは対象次数0とする
      , ccusLevelUpdateDatetime2: dataRow.ccusLevelUpdateDatetime2
      , ccusAllowanceType1: values.ccusAllowanceType1
      , ccusAllowanceInspectionType1: values.ccusAllowanceInspectionType1
      , ccusAllowanceInspectionTime1: ccusInspectionTime1
      , ccusMonthlyAllowanceInspectionDays1: ccusMonthlyInspectionDays1
      , ccusAllowanceAmount1: values.ccusAllowanceType1 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? NaN : parseInt(values.ccusAllowanceAmount1)
      , ccusCeilingDailyAllowanceInspectionDays1: ccusCeilingDailyAllowanceInspectionDays1
      , ccusCeilingDailyAllowanceAmount1: ccusCeilingDailyAllowanceAmount1
      , ccusLevelRangeTo1: values.ccusAllowanceType1 === CONSTANTS.ALLOWANCE_TYPE.NONE.code ? 0 : Number(values.ccusLevelRangeTo1) // 手当区分なしは対象次数0とする
      , ccusLevelUpdateDatetime1: dataRow.ccusLevelUpdateDatetime1
    }
    dispatch(Module.putDataRowAsync(sendRequest))
  }

  // 確定ボタン押下時アクション（入力エラー有）
  const onSubmitFailed = (errorInfo: any) => {
    if (errorInfo.errorFields.length > 0) {
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_VALIDATION")
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setMessages([setMessage]));
    }
  }

  /**
   * 上部へスクロールする（エラーメッセージを見せるため）
   */
  const scrollToTop = () => {
    const target = document.getElementById("contenttop");
    if (target !== null) {
      target.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }

  /**
   * 入力値チェック（相関関係）
   * @returns 
   */
  const validate = (values: any): boolean => {
    let checked: boolean = true;
    let messages: message[] = [];

    // 月手当への切り替え
    if (!validateCeilingDailyAllowance(values.ceilingDailyAllowanceInspectionDays, values.ceilingDailyAllowanceAmount, messages, [""])) {
      checked = false;
    }
    if (!validateCeilingDailyAllowance(values.ccusCeilingDailyAllowanceInspectionDays4, values.ccusCeilingDailyAllowanceAmount4, messages, ["レベル４（金）の"])) {
      checked = false;
    }
    if (!validateCeilingDailyAllowance(values.ccusCeilingDailyAllowanceInspectionDays3, values.ccusCeilingDailyAllowanceAmount3, messages, ["レベル３（銀）の"])) {
      checked = false;
    }
    if (!validateCeilingDailyAllowance(values.ccusCeilingDailyAllowanceInspectionDays2, values.ccusCeilingDailyAllowanceAmount2, messages, ["レベル２（青）の"])) {
      checked = false;
    }
    if (!validateCeilingDailyAllowance(values.ccusCeilingDailyAllowanceInspectionDays1, values.ccusCeilingDailyAllowanceAmount1, messages, ["レベル１（白）の"])) {
      checked = false;
    }

    // 技能レベル適用ありの手当区分１～４
    if (ccusFlagSelected) {
      if (values.ccusAllowanceType1 === CONSTANTS.ALLOWANCE_TYPE.NONE.code
        && values.ccusAllowanceType2 === CONSTANTS.ALLOWANCE_TYPE.NONE.code
        && values.ccusAllowanceType3 === CONSTANTS.ALLOWANCE_TYPE.NONE.code
        && values.ccusAllowanceType4 === CONSTANTS.ALLOWANCE_TYPE.NONE.code) {
        messages.push({
          message: messagesUtils.getMessage("ERROR_CCUS_ALLOWANCE_TYPE_NONE")
          , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
        });
        checked = false;
      }
    }

    if (!checked) {
      dispatch(setMessages(messages));
    }

    return checked;
  }

  /**
   * 月手当への切り替えの入力値チェック（相関関係）
   * @returns 
   */
  const validateCeilingDailyAllowance = (ceilingDailyAllowanceInspectionDays: any, ceilingDailyAllowanceAmount: any, messages: message[], replaceStrings: Array<string>): boolean => {
    let checked: boolean = true;

    if ((isNullOrEmpty(ceilingDailyAllowanceInspectionDays) && !isNullOrEmpty(ceilingDailyAllowanceAmount))
      || (!isNullOrEmpty(ceilingDailyAllowanceInspectionDays) && isNullOrEmpty(ceilingDailyAllowanceAmount))) {
      messages.push({
        message: messagesUtils.getMessage("ERROR_CEILING_DAILY_ALLOWANCE_SETTING", replaceStrings)
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      });
      checked = false;
    }

    return checked;
  }


  // 戻るボタン押下時アクション
  const backClicked = () => {
    if (!window.confirm(messagesUtils.getMessage("CONFIRM_BACK"))) {
      return;
    }
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    if (processType === CONSTANTS.PROCESS_TYPE_ADD) {
      // 登録画面へ遷移します。
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
    } else {
      // 詳細画面へ遷移します。
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_DETAIL);
    }
  }

  /**
   * 描画用メソッド
   * 
   */
  // 独自資格番号部品
  const OriginalQualificationNo = () => {
    if (processType === CONSTANTS.PROCESS_TYPE_ADD) {
      return (
        <DetailForm.Item
          name="originalQualificationNo"
          label="独自資格番号"
          validateFirst={true}
          rules={[
            {
              required: true,
              message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["独自資格番号"])
            },
            {
              max: CONSTANTS.QUALIFICATION_NO_MAX_LENGTH,
              message: messagesUtils.getMessage("ERROR_MAX_LENGTH", ["独自資格番号", CONSTANTS.QUALIFICATION_NO_MAX_LENGTH.toString()])
            },
            {
              pattern: validationRules.alphanumeric,
              message: messagesUtils.getMessage("ERROR_ALPHANUMERIC", ["独自資格番号"]),
            },
          ]}
        >
          <Input className={styles.originalQualificationNo} maxLength={CONSTANTS.QUALIFICATION_NO_MAX_LENGTH} />
        </DetailForm.Item>
      )
    } else {
      return (
        <DetailForm.Item label="独自資格番号">
          <span>{dataRow.originalQualificationNo}</span>
        </DetailForm.Item>
      );
    }
  }

  // 独自資格名部品
  const OriginalQualificationName = () => {
    return (
      <DetailForm.Item
        name="originalQualificationName"
        label="独自資格名"
        validateFirst={true}
        rules={[
          {
            required: true,
            message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["独自資格名"])
          },
          {
            max: CONSTANTS.QUALIFICATION_NAME_MAX_LENGTH,
            message: messagesUtils.getMessage("ERROR_MAX_LENGTH", ["独自資格名", CONSTANTS.QUALIFICATION_NAME_MAX_LENGTH.toString()])
          }
        ]}
      >
        <Input className={styles.originalQualificationName} maxLength={CONSTANTS.QUALIFICATION_NAME_MAX_LENGTH} />
      </DetailForm.Item>
    );
  }

  // パラメータ定義
  interface AllowanceTypeInterface {
    allowanceTypeName: string;
  }
  // 手当区分部品
  const AllowanceType = (props: AllowanceTypeInterface) => {
    const allowanceTypeName = props.allowanceTypeName;
    return (
      <DetailForm.Item
        name={allowanceTypeName}
        label="手当区分"
        validateFirst={true}
        rules={[
          {
            required: true,
            message: messagesUtils.getMessage("ERROR_REQUIRED_SELECT", ["手当区分"])
          }
        ]}
      >
        <Radio.Group buttonStyle={"solid"}>
          {constantsUtils.getCodeLabelListOf(CONSTANTS.ALLOWANCE_TYPE).map((rec: any) => (
            rec.code !== CONSTANTS.ALLOWANCE_TYPE.NONE.code || ccusFlagSelected
              ? <Radio key={rec.code} value={rec.code}>{rec.label}</Radio>
              : <></>
          ))}
        </Radio.Group>
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface AllowanceInspectionTypeInterface {
    allowanceTypeName: string;
    allowanceInspectionTypeName: string;
    allowanceInspectionTimeName: string;
    monthlyAllowanceInspectionDaysName: string;
  }
  // 集計条件部品
  const AllowanceInspectionType = (props: AllowanceInspectionTypeInterface) => {
    const allowanceTypeName = props.allowanceTypeName;
    const allowanceInspectionTypeName = props.allowanceInspectionTypeName;
    const allowanceInspectionTimeName = props.allowanceInspectionTimeName;
    const monthlyAllowanceInspectionDaysName = props.monthlyAllowanceInspectionDaysName;

    return (
      <DetailForm.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues[allowanceTypeName] !== currentValues[allowanceTypeName] || prevValues[allowanceInspectionTypeName] !== currentValues[allowanceInspectionTypeName]}
      >
        {({ getFieldValue }) => {
          if (getFieldValue(allowanceInspectionTypeName) === CONSTANTS.ALLOWANCE_INSPECTION_TYPE.NONE.code) {
            if (getFieldValue(allowanceTypeName) === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
              return (
                <DetailForm.Item
                  label="集計条件"
                  required
                >
                  <AllowanceInspectiontypeRadio name={allowanceInspectionTypeName} />
                  <span>※1分以上の労働時間の入力がある作業日があれば集計対象とする</span>
                </DetailForm.Item>);
            } else if (getFieldValue(allowanceTypeName) === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
              return (
                <DetailForm.Item
                  label="集計条件"
                  required
                >
                  <AllowanceInspectiontypeRadio name={allowanceInspectionTypeName} />
                  <span>※1分以上の労働時間の入力がある作業日を集計対象とする</span>
                </DetailForm.Item>);
            } else {
              return (<></>);
            }

          } else {
            if (getFieldValue(allowanceTypeName) === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
              return (
                <DetailForm.Item
                  label="集計条件"
                  required
                >
                  <AllowanceInspectiontypeRadio name={allowanceInspectionTypeName} />
                  <AllowanceInspectionTime name={allowanceInspectionTimeName} />
                  <MonthlyAllowanceInspectionDays name={monthlyAllowanceInspectionDaysName} />
                </DetailForm.Item>);
            } else if (getFieldValue(allowanceTypeName) === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
              return (
                <DetailForm.Item
                  label="集計条件"
                  required
                >
                  <AllowanceInspectiontypeRadio name={allowanceInspectionTypeName} />
                  <AllowanceInspectionTime name={allowanceInspectionTimeName} />
                </DetailForm.Item>);
            } else {
              return (<></>);
            }
          }
        }}
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface AllowanceInspectiontypeRadioInterface {
    name: string;
  }
  // 手当集計区分部品
  const AllowanceInspectiontypeRadio = (props: AllowanceInspectiontypeRadioInterface) => {
    return (
      <DetailForm.Item
        required={true}
        name={props.name}
        validateFirst={true}
        dependencies={["allowanceType"]}
        rules={[
          {
            required: true,
            message: messagesUtils.getMessage("ERROR_REQUIRED_SELECT", ["手当集計区分"])
          }
        ]}
      >
        <Radio.Group buttonStyle={"solid"}>
          {constantsUtils.getCodeLabelListOf(CONSTANTS.ALLOWANCE_INSPECTION_TYPE).map((rec: any) => (
            <Radio key={rec.code} value={rec.code}>{rec.label}</Radio>
          ))}
        </Radio.Group>
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface AllowanceInspectionTimeInterface {
    name: string;
  }
  // 手当必要時間部品
  const AllowanceInspectionTime = (props: AllowanceInspectionTimeInterface) => {
    return (
      <DetailForm.Item
        required={true}
        name={props.name}
        validateFirst={true}
        dependencies={["allowanceType"]}
        rules={[
          {
            required: true,
            message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["手当必要時間"])
          },
          {
            pattern: validationRules.seisu,
            message: messagesUtils.getMessage("ERROR_ALLOWANCE_TIME_RANGE")
          },
          () => ({
            validator(rule, value) {
              if (value.length > 1 && value.slice(0, 1) === "0") {
                return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_TIME_RANGE"));
              }
              let input = parseInt(value, 10);
              if (input < CONSTANTS.DAILY_ALLOWANCE_TIME_MIN_RANGE || input > CONSTANTS.DAILY_ALLOWANCE_TIME_MAX_RANGE) {
                return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_TIME_RANGE"));
              }
              return Promise.resolve();
            },
          })
        ]}
      >
        <Input className={styles.allowanceTime} addonBefore="１日" addonAfter="時間以上" maxLength={CONSTANTS.DAILY_ALLOWANCE_TIME_MAX_LENGTH} />
      </DetailForm.Item>
    );
  }

  // パラメータ定義
  interface MonthlyAllowanceInspectionDaysInterface {
    name: string;
  }
  // 月手当必要日数部品
  const MonthlyAllowanceInspectionDays = (props: MonthlyAllowanceInspectionDaysInterface) => {
    return (
      <DetailForm.Item
        required={true}
        name={props.name}
        validateFirst={true}
        dependencies={["allowanceType"]}
        rules={[
          {
            required: true,
            message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["月手当必要日数"])
          },
          {
            pattern: validationRules.seisu,
            message: messagesUtils.getMessage("ERROR_ALLOWANCE_DAYS_RANGE")
          },
          () => ({
            validator(rule, value) {
              if (value.length > 1 && value.slice(0, 1) === "0") {
                return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_DAYS_RANGE"));
              }
              let input = parseInt(value, 10);
              if (input >= CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MIN_RANGE && input <= CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MAX_RANGE) {
                return Promise.resolve();
              }
              return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_DAYS_RANGE"));
            },
          })
        ]}
      >
        <Input addonBefore="月" addonAfter="日以上" maxLength={CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MAX_LENGTH} className={styles.allowanceDays} />
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface AllowanceAmountInterface {
    allowanceTypeName: string;
    allowanceAmountName: string;
  }
  // 手当金額部品
  const AllowanceAmount = (props: AllowanceAmountInterface) => {
    const allowanceTypeName = props.allowanceTypeName;
    const allowanceAmountName = props.allowanceAmountName;
    return (
      <DetailForm.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues[allowanceTypeName] !== currentValues[allowanceTypeName]}
      >
        {({ getFieldValue }) => {
          if (getFieldValue(allowanceTypeName) !== CONSTANTS.ALLOWANCE_TYPE.NONE.code) {
            return (
              <>
                <DetailForm.Item
                  name={allowanceAmountName}
                  label="手当金額"
                  dependencies={[allowanceTypeName]}
                  validateFirst={true}
                  rules={[
                    {
                      required: true,
                      message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["手当金額"])
                    },
                    {
                      pattern: validationRules.seisu,
                      message: messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE")
                    },
                    () => ({
                      validator(rule, value) {
                        if (value.length > 1 && value.slice(0, 1) === "0") {
                          return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE"));
                        }
                        let input = parseInt(value, 10);
                        if (input < CONSTANTS.ALLOWANCE_AMOUNT_MIN || input > CONSTANTS.ALLOWANCE_AMOUNT_MAX) {
                          return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE"));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input className={styles.allowanceAmount} addonAfter="円" maxLength={CONSTANTS.ALLOWANCE_AMOUNT_MAX_LENGTH} />
                </DetailForm.Item>
              </>
            );
          } else {
            return (<></>);
          }
        }}
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface LevelRangeToInterface {
    allowanceTypeName: string;
    levelRangeToName: string;
  }
  // 対象次数部品
  const LevelRangeTo = (props: LevelRangeToInterface) => {
    const allowanceTypeName = props.allowanceTypeName;
    const levelRangeToName = props.levelRangeToName;
    return (
      <DetailForm.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues[allowanceTypeName] !== currentValues[allowanceTypeName]}
      >
        {({ getFieldValue }) => {
          if (getFieldValue(allowanceTypeName) !== CONSTANTS.ALLOWANCE_TYPE.NONE.code) {
            return (
              <>
                <DetailForm.Item
                  name={levelRangeToName}
                  label="対象次数"
                  validateFirst={true}
                  rules={[
                    {
                      required: true,
                      message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["対象次数"])
                    },
                  ]}
                >
                  <Select className={styles.authoritySelect}>
                    <Select.Option value={""}>以下からお選びください　▼</Select.Option>
                    {constantsUtils.getCodeLabelListOf(CONSTANTS.LEVEL_RANGE_TO).map((codelabel) => (
                      <Select.Option key={codelabel.code} value={codelabel.code}>{codelabel.label}</Select.Option>
                    ))}
                  </Select>
                </DetailForm.Item>
              </>
            );
          } else {
            return (<></>);
          }
        }}
      </DetailForm.Item>
    )
  }

  // パラメータ定義
  interface CeilingDailyAllowanceAmountInterface {
    ceilingDailyAllowanceInspectionDaysName: string;
    ceilingDailyAllowanceAmountName: string;
  }
  // 日当から月手当に変わる条件部品
  const CeilingDailyAlloanceAmount = (props: CeilingDailyAllowanceAmountInterface) => {
    const ceilingDailyAllowanceInspectionDaysName = props.ceilingDailyAllowanceInspectionDaysName;
    const ceilingDailyAllowanceAmountName = props.ceilingDailyAllowanceAmountName;
    return (
      <DetailForm.Item label="月手当への切り替え">
        <div className={styles.ceilingDailyAllowance}>
          <DetailForm.Item
            name={ceilingDailyAllowanceInspectionDaysName}
            dependencies={["allowanceType"]}
            validateFirst={true}
            rules={[
              {
                pattern: validationRules.seisu,
                message: messagesUtils.getMessage("ERROR_CEILING_DAILY_ALLOWANCE_INSPECTION_DAYS_RANGE")
              },
              () => ({
                validator(rule, value) {
                  if (value != null) {
                    if (value.length > 1 && value.slice(0, 1) === "0") {
                      return Promise.reject(messagesUtils.getMessage("ERROR_CEILING_DAILY_ALLOWANCE_INSPECTION_DAYS_RANGE"));
                    }
                    let input = parseInt(value, 10);
                    if (input < CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MIN_RANGE || CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MAX_RANGE < input) {
                      return Promise.reject(messagesUtils.getMessage("ERROR_CEILING_DAILY_ALLOWANCE_INSPECTION_DAYS_RANGE"));
                    }
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input className={styles.ceilingDailyAllowanceInspectionDays} addonBefore="労働日数が" addonAfter="日" maxLength={CONSTANTS.MONTHLY_ALLOWANCE_DAYS_MAX_LENGTH} />
          </DetailForm.Item>
          <span>以上の場合は</span>
          <DetailForm.Item
            name={ceilingDailyAllowanceAmountName}
            dependencies={["allowanceType"]}
            validateFirst={true}
            rules={[
              {
                pattern: validationRules.seisu,
                message: messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE")
              },
              () => ({
                validator(rule, value) {
                  if (value != null) {
                    if (value.length > 1 && value.slice(0, 1) === "0") {
                      return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE"));
                    }
                    let input = parseInt(value, 10);
                    if (input < CONSTANTS.ALLOWANCE_AMOUNT_MIN || input > CONSTANTS.ALLOWANCE_AMOUNT_MAX) {
                      return Promise.reject(messagesUtils.getMessage("ERROR_ALLOWANCE_AMOUNT_RANGE"));
                    }
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input className={styles.ceilingDailyAllowanceAmount} addonBefore="定額" addonAfter="円" maxLength={CONSTANTS.ALLOWANCE_AMOUNT_MAX_LENGTH} />
          </DetailForm.Item>
          <span>となります</span>
        </div>
        <div className={styles.note}>
          手当金額を労働日数に応じて日額から月額（定額）に切り替えたい場合はこちらの項目を設定してください。
        </div>
      </DetailForm.Item>
    )
  }

  // 有効期限部品
  const Deadline = () => {
    return (
      <>
        <DetailForm.Item label="有効期限" >
          <div className={styles.deadLineDuration}>
            <span className={styles.label}>なし</span>
            <DetailForm.Item name="deadlineExist" valuePropName="checked" style={{ display: "inline" }}>
              <Switch
                defaultChecked={dataRow.deadlineExist === CONSTANTS.EXIST_DEADLINE.EXIST.code ? true : false}
                className={styles.deadlineExist}
              />
            </DetailForm.Item>
            <span className={styles.label}>あり</span>
          </div>
          <DetailForm.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => prevValues.deadlineExist !== currentValues.deadlineExist}
          >
            {({ getFieldValue }) => {
              return getFieldValue('deadlineExist') === true ? (
                <div className={styles.deadLineDuration}>
                  <DetailForm.Item
                    name="deadlineStartDate"
                    validateFirst={true}
                    dependencies={['deadlineEndDate']}
                    className={styles.startDate}
                    rules={[
                      ({ getFieldValue, setFields, isFieldValidating }) => ({
                        validator(rule, value) {
                          if (value === null) {
                            if (getFieldValue('deadlineEndDate') !== null) {
                              setFields([{ name: 'deadlineEndDate', errors: [] }]);
                            }
                            return Promise.reject(messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["有効期限開始日"]));
                          }
                          if (getFieldValue('deadlineEndDate') === null) {
                            return Promise.resolve();
                          }
                          if (getFieldValue('deadlineEndDate').isSameOrBefore(value, 'day')) {
                            return Promise.reject(messagesUtils.getMessage("ERROR_DEADLINE_RANGE_START_DATE"));
                          }
                          if (getFieldValue('deadlineEndDate') !== null && !isFieldValidating("deadlineEndDate")) {
                            setFields([{ name: 'deadlineEndDate', errors: [] }]);
                          }
                          // 資格編集時に、既に認定日がある資格は、その最小認定日よりも前の有効開始日を入力すればエラー表示
                          if (value.isAfter(dataRow.minCertDate)) {
                            const minCertDateJST = new Date(dataRow.minCertDate);
                            const options: Intl.DateTimeFormatOptions = {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              timeZone: 'Asia/Tokyo'
                            };
                            const resMinCertDate = minCertDateJST.toLocaleDateString('ja-JP', options);

                            return Promise.reject(messagesUtils.getMessage("ERROR_CERTIFICATION_AFTER_START_DATE", [resMinCertDate, resMinCertDate]));
                          }
                          return Promise.resolve();
                        }
                      })
                    ]}
                  >
                    <DatePicker />
                  </DetailForm.Item>
                  <span>～</span >
                  <DetailForm.Item
                    name="deadlineEndDate"
                    validateFirst={true}
                    dependencies={['deadlineStartDate']}
                    className={styles.endDate}
                    rules={[
                      ({ getFieldValue, validateFields, setFields, isFieldValidating }) => ({
                        validator(rule, value) {
                          if (value === null) {
                            if (getFieldValue('deadlineStartDate') !== null) {
                              setFields([{ name: 'deadlineStartDate', errors: [] }]);
                            }
                            return Promise.reject(messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["有効期限終了日"]));
                          }
                          if (getFieldValue('deadlineStartDate') === null && !isFieldValidating("deadlineStartDate")) {
                            validateFields(["deadlineStartDate"]);
                            return Promise.resolve();
                          }
                          if (getFieldValue('deadlineStartDate') !== null && getFieldValue('deadlineStartDate').isSameOrAfter(value, 'day')) {
                            return Promise.reject(messagesUtils.getMessage("ERROR_DEADLINE_RANGE_END_DATE"));
                          }
                          if (getFieldValue('deadlineStartDate') !== null && !isFieldValidating("deadlineStartDate")) {
                            setFields([{ name: 'deadlineStartDate', errors: [] }]);
                          }
                          // 登録されている技能者資格の、（最大認定日or最大認定取消日の未来の方）よりも前の有効終了日を入力すればエラー
                          if (getFieldValue('deadlineStartDate') && value.isBefore(dataRow.maxCertDate)) {
                            const maxCertDateJST = new Date(dataRow.maxCertDate);
                            const options: Intl.DateTimeFormatOptions = {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              timeZone: 'Asia/Tokyo'
                            };
                            const resMaxCertDate = maxCertDateJST.toLocaleDateString('ja-JP', options);
                            return Promise.reject(messagesUtils.getMessage("ERROR_CERTIFICATION_BEFORE_END_DATE", [resMaxCertDate, resMaxCertDate]));
                          }
                          return Promise.resolve();
                        }
                      })
                    ]}
                  >
                    <DatePicker />
                  </DetailForm.Item >
                </div>
              ) : null;
            }}
          </DetailForm.Item>
        </DetailForm.Item>
      </>
    )
  }

  // 備考部品
  const Reamarks = () => {
    return (
      <>
        <DetailForm.Item
          name="remarks1"
          label="備考１"
          validateFirst={true}
          rules={[
            () => ({
              validator(rule, value) {
                if (value.replace(/\n/, "").length > CONSTANTS.REMARKS1_MAX_LENGTH) {
                  return Promise.reject(messagesUtils.getMessage("ERROR_MAX_LENGTH", ["備考１", CONSTANTS.REMARKS1_MAX_LENGTH.toString()]));
                }
                return Promise.resolve();
              }
            })
          ]}
        >
          <TextArea rows={4} maxLength={CONSTANTS.REMARKS1_MAX_LENGTH} />
        </DetailForm.Item>

        <DetailForm.Item
          name="remarks2"
          label="備考２"
          validateFirst={true}
          rules={[
            () => ({
              validator(rule, value) {
                if (value.replace(/\n/, "").length > CONSTANTS.REMARKS2_MAX_LENGTH) {
                  return Promise.reject(messagesUtils.getMessage("ERROR_MAX_LENGTH", ["備考２", CONSTANTS.REMARKS2_MAX_LENGTH.toString()]));
                }
                return Promise.resolve();
              }
            })
          ]}
        >
          <TextArea rows={4} maxLength={CONSTANTS.REMARKS2_MAX_LENGTH} />
        </DetailForm.Item>
      </>
    )
  }

  // パラメータ定義
  interface CcusAllowanceTypeInterface {
    ccusLevel: number;
  }
  // 手当区分部品(CCUS用)
  const CcusAllowanceType = (props: CcusAllowanceTypeInterface) => {
    const ccusLevel = props.ccusLevel;

    return <AllowanceType allowanceTypeName={"ccusAllowanceType" + ccusLevel} />
  }

  // パラメータ定義
  interface CcusAllowanceInspectionTypeInterface {
    ccusLevel: number;
  }
  // 集計条件部品(CCUS用)
  const CcusAllowanceInspectionType = (props: CcusAllowanceInspectionTypeInterface) => {
    const ccusLevel = props.ccusLevel;

    return <AllowanceInspectionType
      allowanceTypeName={"ccusAllowanceType" + ccusLevel}
      allowanceInspectionTypeName={"ccusAllowanceInspectionType" + ccusLevel}
      allowanceInspectionTimeName={"ccusAllowanceInspectionTime" + ccusLevel}
      monthlyAllowanceInspectionDaysName={"ccusMonthlyAllowanceInspectionDays" + ccusLevel}
    />
  }

  // パラメータ定義
  interface CcusAllowanceAmountInterface {
    ccusLevel: number;
  }
  // 手当金額部品(CCUS用)
  const CcusAllowanceAmount = (props: CcusAllowanceAmountInterface) => {
    return <AllowanceAmount
      allowanceTypeName={"ccusAllowanceType" + props.ccusLevel}
      allowanceAmountName={"ccusAllowanceAmount" + props.ccusLevel}
    />
  }

  // パラメータ定義
  interface CcusLevelRangeToInterface {
    ccusLevel: number;
  }
  // 対象次数部品(CCUS用)
  const CcusLevelRangeTo = (props: CcusLevelRangeToInterface) => {
    return <LevelRangeTo
      allowanceTypeName={"ccusAllowanceType" + props.ccusLevel}
      levelRangeToName={"ccusLevelRangeTo" + props.ccusLevel}
    />
  }

  // パラメータ定義
  interface CcusCeilingDailyAllowanceAmountInterface {
    ccusLevel: number;
  }
  // 日当から月手当に変わる条件部品(CCUS用)
  const CcusCeilingDailyAlloanceAmount = (props: CcusCeilingDailyAllowanceAmountInterface) => {
    return <CeilingDailyAlloanceAmount
      ceilingDailyAllowanceInspectionDaysName={"ccusCeilingDailyAllowanceInspectionDays" + props.ccusLevel}
      ceilingDailyAllowanceAmountName={"ccusCeilingDailyAllowanceAmount" + props.ccusLevel}
    />
  }

  // 技能レベル適用部品
  const CcusFlagFrom = () => {
    return (
      <>
        <DetailForm
          form={form}
          className={styles.editform}
          initialValues={{
            'ccusFlagSelected': ccusFlagSelected
          }}
          onFinish={onSubmit}
          onFinishFailed={onSubmitFailed}
        >
          <DetailForm.Item label="技能レベル適用" >
            <div className={styles.deadLineDuration}>
              <span className={styles.label}>なし</span>
              <DetailForm.Item name="ccusFlagSelected" valuePropName="checked" style={{ display: "inline" }}>
                <Switch
                  defaultChecked={ccusFlagSelected}
                  className={styles.deadlineExist}
                  onChange={onChangeCcusFlag}
                />
              </DetailForm.Item>
              <span className={styles.label}>あり</span>
            </div>
          </DetailForm.Item>
        </DetailForm>
        <br /><br /><br />
        {ccusFlagSelected ? <CcusForm /> : <EditForm />}
        <br /><br /><br />
      </>
    )
  }

  // パラメータ定義
  interface CcusLevelFormInterface {
    ccusLevel: number;
  }
  // CCUSレベル別部品
  const CcusLevelForm = (props: CcusLevelFormInterface) => {
    const ccusLevel = props.ccusLevel;
    const levelLabel = ccusLevel == 4 ? "レベル４（金）" : ccusLevel == 3 ? "レベル３（銀）" : ccusLevel == 2 ? "レベル２（青）" : "レベル１（白）";

    const allowanceTypeName = "ccusAllowanceType" + ccusLevel;
    const allowanceInspectionTypeName = "ccusAllowanceInspectionType" + ccusLevel;
    const allowanceInspectionTimeName = "ccusAllowanceInspectionTime" + ccusLevel;
    const monthlyAllowanceInspectionDaysName = "ccusMonthlyAllowanceInspectionDays" + ccusLevel;
    const allowanceAmountName = "ccusAllowanceAmount" + ccusLevel;
    const levelRangeToName = "ccusLevelRangeTo" + ccusLevel;
    const ceilingDailyAllowanceAmountName = "ccusCeilingDailyAllowanceAmount" + ccusLevel;
    const ceilingDailyAllowanceInspectionDaysName = "ccusCeilingDailyAllowanceInspectionDays" + ccusLevel;

    const allowanceType = dataRow["ccusAllowanceType" + ccusLevel];
    const allowanceInspectionType = dataRow["ccusAllowanceInspectionType" + ccusLevel];
    const allowanceInspectionTime = dataRow["ccusAllowanceInspectionTime" + ccusLevel];
    const monthlyAllowanceInspectionDays = dataRow["ccusMonthlyAllowanceInspectionDays" + ccusLevel];
    const allowanceAmount = dataRow["ccusAllowanceAmount" + ccusLevel];
    const levelRangeTo = dataRow["ccusLevelRangeTo" + ccusLevel];
    const ceilingDailyAllowanceAmount = dataRow["ccusCeilingDailyAllowanceAmount" + ccusLevel];
    const ceilingDailyAllowanceInspectionDays = dataRow["ccusCeilingDailyAllowanceInspectionDays" + ccusLevel];

    const initialValues: any = {};
    initialValues[allowanceTypeName] = allowanceType;
    initialValues[allowanceInspectionTypeName] = allowanceInspectionType;
    initialValues[allowanceInspectionTimeName] = allowanceInspectionTime === null ? 1 : allowanceInspectionTime;
    initialValues[monthlyAllowanceInspectionDaysName] = monthlyAllowanceInspectionDays === null ? 0 : monthlyAllowanceInspectionDays;
    initialValues[allowanceAmountName] = allowanceAmount === null ? 0 : allowanceAmount;
    initialValues[levelRangeToName] = constantsUtils.getCodeLabelListOf(CONSTANTS.LEVEL_RANGE_TO).map(codelabel => codelabel.code).includes(String(levelRangeTo)) ? String(levelRangeTo) : "";
    initialValues[ceilingDailyAllowanceAmountName] = isNullOrNan(ceilingDailyAllowanceAmount) ? "" : ceilingDailyAllowanceAmount;
    initialValues[ceilingDailyAllowanceInspectionDaysName] = isNullOrNan(ceilingDailyAllowanceInspectionDays) ? "" : ceilingDailyAllowanceInspectionDays;

    return (
      <>
        <div className={styles.headline}>
          <span>{levelLabel}</span>
        </div>
        <DetailForm
          form={form}
          className={styles.editform}
          initialValues={initialValues}
          onFinish={onSubmit}
          onFinishFailed={onSubmitFailed}
        >

          <CcusAllowanceType ccusLevel={ccusLevel} />
          <CcusAllowanceInspectionType ccusLevel={ccusLevel} />
          <CcusAllowanceAmount ccusLevel={ccusLevel} />
          <CcusLevelRangeTo ccusLevel={ccusLevel} />
          <DetailForm.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => prevValues[allowanceTypeName] !== currentValues[allowanceTypeName]}
          >
            {({ getFieldValue }) => {
              return getFieldValue(allowanceTypeName) === CONSTANTS.ALLOWANCE_TYPE.DAILY.code ? (
                <CcusCeilingDailyAlloanceAmount ccusLevel={ccusLevel} />
              ) : (<></>);
            }}
          </DetailForm.Item>
        </DetailForm>
      </>
    );
  }

  // 編集Formを描画します。（技能レベル適用あり）
  const CcusForm = () => {
    return (
      <>
        <DetailForm
          form={form}
          className={styles.editform}
          initialValues={{
            'originalQualificationNo': dataRow.originalQualificationNo
            , 'originalQualificationName': dataRow.originalQualificationName
            , 'allowanceType': dataRow.allowanceType
            , 'allowanceInspectionType': dataRow.allowanceInspectionType
            , 'allowanceInspectionTime': dataRow.allowanceInspectionTime === null ? 1 : dataRow.allowanceInspectionTime
            , 'monthlyAllowanceInspectionDays': dataRow.monthlyAllowanceInspectionDays === null ? 0 : dataRow.monthlyAllowanceInspectionDays
            , 'allowanceAmount': dataRow.allowanceAmount === null ? 0 : dataRow.allowanceAmount
            , 'ceilingDailyAllowanceInspectionDays': isNullOrNan(dataRow.ceilingDailyAllowanceInspectionDays) ? "" : dataRow.ceilingDailyAllowanceInspectionDays
            , 'ceilingDailyAllowanceAmount': isNullOrNan(dataRow.ceilingDailyAllowanceAmount) ? "" : dataRow.ceilingDailyAllowanceAmount
            , 'deadlineExist': dataRow.deadlineExist === CONSTANTS.EXIST_DEADLINE.EXIST.code ? true : false
            , 'deadlineStartDate': isNullOrEmpty(dataRow.deadlineStartDate) ? null : moment(dataRow.deadlineStartDate)
            , 'deadlineEndDate': isNullOrEmpty(dataRow.deadlineEndDate) ? null : moment(dataRow.deadlineEndDate)
            , 'levelRangeTo': constantsUtils.getCodeLabelListOf(CONSTANTS.LEVEL_RANGE_TO).map(codelabel => codelabel.code).includes(String(dataRow.levelRangeTo)) ? String(dataRow.levelRangeTo) : ""
            , 'remarks1': dataRow.remarks1 !== null ? dataRow.remarks1 : ""
            , 'remarks2': dataRow.remarks2 !== null ? dataRow.remarks2 : ""
          }}
          onFinish={onSubmit}
          onFinishFailed={onSubmitFailed}
        >
          <OriginalQualificationNo />
          <OriginalQualificationName />
          <Deadline />
          <Reamarks />

          <div className={styles.fixed}>
            <div className={styles.float}>
              <AuthButton
                name={"戻る"}
                size={"large"}
                shape={"round"}
                onClick={backClicked}
                className={AuthButtonStyles.backButtonFixed}
              />
              <AuthButton
                name={"確定"}
                htmlType="submit"
                size={"large"}
                shape={"round"}
                className={AuthButtonStyles.authButtonFixed}
              />
            </div>
          </div>
        </DetailForm>

        <br /><br /><br />

        <CcusLevelForm ccusLevel={4} />
        <CcusLevelForm ccusLevel={3} />
        <CcusLevelForm ccusLevel={2} />
        <CcusLevelForm ccusLevel={1} />

        <br /><br /><br />
      </>
    )
  }

  // 編集Formを描画します。（技能レベル適用なし）
  const EditForm = () => {
    return (
      <>
        <DetailForm
          form={form}
          className={styles.editform}
          initialValues={{
            'originalQualificationNo': dataRow.originalQualificationNo
            , 'originalQualificationName': dataRow.originalQualificationName
            , 'allowanceType': dataRow.allowanceType
            , 'allowanceInspectionType': dataRow.allowanceInspectionType
            , 'allowanceInspectionTime': dataRow.allowanceInspectionTime === null ? 1 : dataRow.allowanceInspectionTime
            , 'monthlyAllowanceInspectionDays': dataRow.monthlyAllowanceInspectionDays === null ? 0 : dataRow.monthlyAllowanceInspectionDays
            , 'allowanceAmount': dataRow.allowanceAmount === null ? 0 : dataRow.allowanceAmount
            , 'ceilingDailyAllowanceInspectionDays': isNullOrNan(dataRow.ceilingDailyAllowanceInspectionDays) ? "" : dataRow.ceilingDailyAllowanceInspectionDays
            , 'ceilingDailyAllowanceAmount': isNullOrNan(dataRow.ceilingDailyAllowanceAmount) ? "" : dataRow.ceilingDailyAllowanceAmount
            , 'deadlineExist': dataRow.deadlineExist === CONSTANTS.EXIST_DEADLINE.EXIST.code ? true : false
            , 'deadlineStartDate': isNullOrEmpty(dataRow.deadlineStartDate) ? null : moment(dataRow.deadlineStartDate)
            , 'deadlineEndDate': isNullOrEmpty(dataRow.deadlineEndDate) ? null : moment(dataRow.deadlineEndDate)
            , 'levelRangeTo': constantsUtils.getCodeLabelListOf(CONSTANTS.LEVEL_RANGE_TO).map(codelabel => codelabel.code).includes(String(dataRow.levelRangeTo)) ? String(dataRow.levelRangeTo) : ""
            , 'remarks1': dataRow.remarks1 !== null ? dataRow.remarks1 : ""
            , 'remarks2': dataRow.remarks2 !== null ? dataRow.remarks2 : ""
          }}
          onFinish={onSubmit}
          onFinishFailed={onSubmitFailed}
        >
          <OriginalQualificationNo />
          <OriginalQualificationName />
          <AllowanceType allowanceTypeName='allowanceType' />
          <AllowanceInspectionType
            allowanceTypeName={"allowanceType"}
            allowanceInspectionTypeName={"allowanceInspectionType"}
            allowanceInspectionTimeName={"allowanceInspectionTime"}
            monthlyAllowanceInspectionDaysName={"monthlyAllowanceInspectionDays"}
          />
          <AllowanceAmount
            allowanceTypeName={"allowanceType"}
            allowanceAmountName={"allowanceAmount"}
          />
          <LevelRangeTo
            allowanceTypeName={"allowanceType"}
            levelRangeToName={"levelRangeTo"}
          />

          <DetailForm.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => prevValues.allowanceType !== currentValues.allowanceType}
          >
            {({ getFieldValue }) => {
              return getFieldValue('allowanceType') === CONSTANTS.ALLOWANCE_TYPE.DAILY.code ? (
                <CeilingDailyAlloanceAmount
                  ceilingDailyAllowanceInspectionDaysName='ceilingDailyAllowanceInspectionDays'
                  ceilingDailyAllowanceAmountName='ceilingDailyAllowanceAmount'
                />
              ) : (<></>);
            }}
          </DetailForm.Item>

          <Deadline />

          <Reamarks />

          <div className={styles.fixed}>
            <div className={styles.float}>
              <AuthButton
                name={"戻る"}
                size={"large"}
                shape={"round"}
                onClick={backClicked}
                className={AuthButtonStyles.backButtonFixed}
              />
              <AuthButton
                name={"確定"}
                htmlType="submit"
                size={"large"}
                shape={"round"}
                className={AuthButtonStyles.authButtonFixed}
              />
            </div>
          </div>
        </DetailForm>
        <br /><br /><br />
      </>
    )
  }

  return (
    <Layout>
      <Header />
      <Content hasapicall={"false"}>
        <FunctionTitle title={props.title} />
        <div id="contenttop" />
        <CommonMessage />
        <CcusFlagFrom />
      </Content>
      <FooterButtonArea hasapicall={"false"} />
      <Footer />
    </Layout >
  );
}

